import { AxiosError } from 'axios';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import { useRerunProduct } from '@/hooks/useRerunProduct';
import { VisionStatus } from '@/services/ProductsService';

interface RerunButtonProps {
  catalogId: number;
  visionStatus: VisionStatus;
}

export function RerunButton({ catalogId, visionStatus }: RerunButtonProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.VisionProduct.components.RerunButton',
  });

  const { rerunProduct, isLoading } = useRerunProduct(catalogId);

  async function handleRerun() {
    if (visionStatus !== VisionStatus.SUCCESS) {
      return;
    }

    try {
      await rerunProduct({ catalogId });
    } catch (error) {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.message
          : t('error');
      toast.error(message);
    }
  }

  return (
    <Button
      onClick={handleRerun}
      disabled={isLoading || visionStatus !== VisionStatus.SUCCESS}
      variant="outline"
      className="flex items-center gap-2 bg-transparent"
    >
      <RefreshCw
        className={`h-4 w-4 ${visionStatus !== VisionStatus.SUCCESS ? 'animate-spin' : ''}`}
      />
      {visionStatus === VisionStatus.SUCCESS ? t('label') : t('rerunning')}
    </Button>
  );
}
